import styled, {ThemeProps} from 'styled-components';
import {Assign} from 'utility-types';
import {
  ButtonBase,
  PrimaryLink,
} from '../../../../../../stories/components/CommonStyleUtils/dwebCommon.styles';

// STYLES
import {
  HiddenDropdownWrapperDiv,
  HoverTargetWrapperDiv,
  TipUI,
} from '../../../../../../stories/components/hotels/SRP/AmenitiesList/AmenitiesList.styles';

// COLOR Palette
import {defaultTheme, textSizes} from '@stencil/build-theme';
import {Theme} from 'build-theme/src/types';

import {Column, Row} from '../../../../../../stories/components/hotels/common/Layouts/Layouts';

export const RoomFlavorColumn = styled.div(props => {
  return `
      border-right: .1rem solid ${props.theme.colors.goBrandBlue.light};
      padding: ${props.hideMultiRoomModal ? '' : '2.55rem'};
      &:last-child {
        border-right: none;
      }
      ${props.isMultiroom ? 'width:63%' : 'flex:1'};
      height:auto;
      text-align:${props.isMultiroom ? 'end' : ''};
  `;
});

export const InclusionsRoomFlavorColumn = styled(RoomFlavorColumn)(props => {
  return `
  `;
});

export const RoomOptionsHeadingTextStyle = styled.h4(
  props => `
  // padding-top: ${props.theme.spacing.base};
  padding-bottom: ${props.theme.spacing.base};
  font-size: ${props.theme.font.custom(14)};
  font-weight: 600;
  word-break: break-word;
`,
);

export const RoomHeadingContainer = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 27px;
`;

export const RoomOptionsBody = styled.div``;

export const RecommendedLabelContainer = styled(Column)(
  props => `
  // width: 50%
`,
);

export const RecommendedLabelWrapper = styled(Column)(
  props => `
  background-image: linear-gradient(281deg, #ff6d38, #ff3a5c);
  padding: ${props.theme.spacing.small} ${props.theme.spacing.base} ${props.theme.spacing.small} ${props.theme.spacing.base};
  position: relative;
  border-radius: ${props.theme.misc.borderRadius.small};
  width:11rem;
  margin-bottom:${props.theme.spacing.base};
`,
);

export const RecommendedLabelPrependStyles = styled.span(
  props => `
  &::after{
    display: flex;
    content: '';
    border-top: 1.2rem solid transparent;
    border-bottom: 1.2rem solid transparent;
    position: absolute;
    border-left: 0.8rem solid white;
    left: 0px;
    top: 0px;
  }
`,
);

export const RecommendedTextStyled = styled.span(
  props => `
  color: white;
  font-weight: 600;
  padding-left: ${props.theme.spacing.small};
`,
);

export const RoomFlavorWrap = styled.div(
  (props: Assign<ThemeProps<Theme>, {lastIndex: boolean}>) => {
    const borderBottom = props.lastIndex
      ? 'none'
      : `0.8rem solid ${props.theme.colors.goBrandBlue.light}`;
    const height = props.lastIndex ? '100%' : `auto`;

    return `
    display: flex;
    width: 100%;
    border-bottom: ${borderBottom};
    height: ${height};
  `;
  },
);

export const CashBackStyledContainer = styled(Row)(
  props => `
  padding: ${props.theme.spacing.small} ${props.theme.spacing.base} ${props.theme.spacing.small} ${props.theme.spacing.base};
  align-items: center;
  justify-content: center;
  position: relative;
  border: 0.1rem solid ${props.theme.colors.goYellow.dark};
  background-color: ${props.theme.colors.goYellow.light};
  border-radius: ${props.theme.misc.borderRadius.base};
  width: 70%;
`,
);

export const CashbackStyledTextStyled = styled.span(
  props => `
  font-weight: 600;
  color: ${props.theme.colors.goZest.dark};

  &::before {
    display: flex;
    content: '';
    border-top: 1.1rem solid transparent;
    border-bottom: 1rem solid transparent;
    position: absolute;
    border-left: 0.8rem solid ${props.theme.colors.goYellow.light};
    right: -0.8rem;
    top: 0;
  }
`,
);

export const StrikeThroughPersuasionPriceTextStyled = styled.span(
  props => `
  padding: ${props.theme.spacing.large} 0 0 0;
  color: ${props.theme.colors.downriver.medium};
  text-decoration: line-through;
`,
);

export const ActualPriceTextStyled = styled.div(
  props => `
  display:flex;
  align-items:center;
  font-size: ${props.theme.font.custom(22)};
  font-weight: 600;
  justify-content:${props.isMultiroom ? 'flex-end' : ''}
`,
);

// from Abinash - should use defaultTheme instead of directly accessing defaultTheme.colors
export const actualPriceRupeeIconProps = {
  fill: defaultTheme.colors.downriver.base,
  width: '1.4rem',
  height: '1.4rem',
};

export const TaxesTextStyled = styled.span`
  ${textSizes.SmallW1}
`;

export const PerRoomNightTextStyled = styled.p(
  props => `
  padding: ${
    props.padding ? props.padding : `${props.theme.spacing.small} 0 ${props.theme.spacing.base} 0`
  };
  color: ${props.theme.colors.downriver.medium};
`,
);

export const ButtonWrapper = styled(ButtonBase)`
  ${textSizes.BaseW2}
  border: 0.15rem solid ${props => props.theme.colors.goBrandOrange.base};
  background: ${props => props.theme.colors.goWhite.base};
  color: ${props => props.theme.colors.goBrandOrange.base};
  padding: 0 ${props => props.theme.spacing.custom(28)};
  margin-bottom: ${props => props.theme.spacing.base};
  height: 4.4rem;
  &:hover {
    background: ${props => props.theme.colors.goBrandOrange.base};
    color: ${props => props.theme.colors.goWhite.base};
  }
`;

export const EMICTAText = styled.div(
  props => `
  color: ${props.theme.colors.goBrandBlue.base};
  padding: ${props.theme.spacing.xsmall} 0 ${props.theme.spacing.xxlarge};
  font-size: ${props.theme.font.custom(14)};
  font-weight: 600;
`,
);

export const InclusionsIconContainer = styled.span(
  props => `
  margin: 0 ${props.theme.spacing.base} 0 0;
  display: flex;
  align-items: center;
  transform: translateY(0.3rem); /* to compensate for font face and svg idiocracies */
`,
);

export const BulletTextSpan = styled.span(
  props => `
    font-size:${!props.isMultiRoom ? props.theme.font.custom(14) : '12px'};
    `,
);

export const BulletPointOuter = styled.div(
  props => `
    display:flex;
    width:6%;
    `,
);

export const BulletPoint = styled.span(
  props => `
    background-color:${props.theme.colors.downriver.base};
    // border-radius: ${props.theme.misc.borderRadius.xxxlarge};

    border-radius: 50%;
    width: 0.6rem;
    height: 0.6rem;
    margin-right: ${props.theme.spacing.small};
    `,
);

export const ShowMoreAmenitiesText = styled.div(
  props => `
  padding: ${props.theme.spacing.small} 0;
  color: ${props.theme.colors.goBrandBlue.base};
  cursor: pointer;ew
`,
);

export const ShowMoreAmenitiesHiddenDropDownContainer = styled(HiddenDropdownWrapperDiv)`
  top: 2rem;
  right: 2rem;
  bottom: 0rem;
  left: 0rem;
`;

export const AmenitiesDropDownWrapper = styled.div(
  props => `
  background: ${props.theme.colors.goRed.light};
  font-size: ${props.theme.font.custom(14)};
  padding: ${props.theme.spacing.base} ${props.theme.spacing.large};
  min-width: 360px;
  z-index: ${props.theme.misc.zIndex.small};
`,
);

export const HoverList = styled.ul(
  props => `
  list-style-type: none;
`,
);

export const HoverListItem = styled.li(
  props => `
  padding: ${props.theme.spacing.small} 0;
`,
);

export const SpecialInstructionsContainer = styled.div(
  props => `
  color: ${props.theme.colors.goRed.base};
  font-size: ${props.theme.font.custom(14)};
  margin: ${props.theme.spacing.small} 0 0 -${
    props.theme.spacing.small
  }; /* left margin for svg shape quirk */
  display: flex;
`,
);

export const SpecialInstructionsLabelTextContainer = styled.div(
  props => `
  padding: 0 0 0 ${props.theme.spacing.small};
  >div{
    padding: ${props.theme.spacing.small} 0;
  }
`,
);

export const SpecialInstructionsLabelText = styled.span`
  margin: 1px 0 0 0; /* to compensate for font type face quirks */
`;

export const SplInstructionsViewDetailsText = styled.div(
  props => `
  padding: ${props.theme.spacing.small} 0;
  color: ${props.theme.colors.goBrandBlue.base};
  cursor: pointer;
`,
);

export const HoverTargetWrapperDivForSplInstructions = styled(HoverTargetWrapperDiv)`
  display: block;
`;

export const ExclamationIconContainer = styled.div`
  margin: -3px 0 0 0; /** to compensate for svg quirk */
`;
export const TipPositioning = styled(TipUI)(
  props => `
  left: 15%;
  top: -0.2rem;
  &::after {
    transform: translate(-50%, 50%) rotate(45deg);
    box-shadow: 0 ${props.theme.spacing.xxsmall} ${props.theme.spacing.custom(4)}
      ${props.theme.colors.shadow.base};
    background: ${props.theme.colors.goRed.light};

  }
`,
);

export const RoomOptionsIconContainer = styled.div(
  props => `
  padding: 0 ${props.theme.spacing.base} 0 0;
`,
);

export const CancellationPolicyContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const MemberPriceWrapDiv = styled.div(
  props => `
  width: 50%;
  border:.1rem solid ${props.theme.colors.goBrandBlue.light};
  border-radius: ${props.theme.misc.borderRadius.xxxlarge};
  border-top-left-radius:0;
  padding: ${props.theme.spacing.small};
  margin-bottom:${props.theme.spacing.custom(8)};
`,
);

export const MemberPriceTag = styled.span(
  props => `
  width:34%;
  border-radius: ${props.theme.misc.borderRadius.xlarge};
  border-bottom-left-radius:0;
  border-bottom-right-radius:0;
  padding: ${props.theme.spacing.custom(2)} ${props.theme.spacing.small};
  color: ${props.theme.colors.goWhite.base};
  font-size:${props.theme.font.custom(11)};
  font-weight: 600;
  background-image: linear-gradient(282deg, #f87f46, #f4a900);
`,
);

export const OuterBlockWrapper = styled.span(
  props => `
    position:relative;
    display:flex;
    margin-bottom:10px;
    `,
);

export const PercentageOffWrapperDiv = styled.div(
  props => `
    display:flex;
    background-color: ${props.bgColor || props.theme.colors.goRed.dark};
    border-radius: ${props.theme.misc.borderRadius.custom(5)};
    // border-top-left-radius: ${props.theme.misc.borderRadius.custom(5)};
    // border-bottom-right-radius: ${props.theme.misc.borderRadius.custom(5)};
    // border-bottom-left-radius: ${props.theme.misc.borderRadius.custom(5)};
    color:${props.textColor || props.theme.colors.goWhite.base};
    margin-right:${props.theme.spacing.base};
    padding:${props.theme.spacing.xsmall} ${props.theme.spacing.large} ${
      props.theme.spacing.xsmall
    } ${props.theme.spacing.small} ;
    cursor:pointer;

  `,
);

export const PercentageLabelStyles = styled.span(
  props => `
      display: flex;
      content: '';
      border-top: 1rem solid transparent;
      border-bottom: 0.8rem solid transparent;
      position: relative;
      left:-1.3rem;
      border-left: 0.6rem solid #E63148;
  `,
);

export const ViewPlanDetailsPoliciesBtn = styled(PrimaryLink)(
  props => `
    font-size: ${props.theme.font.custom(14)};
    color:${props.customColor || props.theme.colors.goBrandBlue.base};
    font-weight: 600;
    padding-top:${props.isNoRefundText ? '1rem' : ''};
    margin-left:19px;
    `,
);

export const LoginForMore = styled.span(
  props => `
         font-size: ${props.theme.font.custom(14)};
         font-weight: 600;
       `,
);

// GO TRIBE
export const GoTribeTextInnerWrapper = styled.div`
  a {
    color: #2276e3;
    ${textSizes.SmallW3};
  }
  margin-bottom: 3px;
`;
export const headerWrapper = styled.div`
  display: flex;
  align-items: center;
`;
export const GoTribeTextWrapper = styled.div`
  display: flex;
  margin-top: 1rem;
  position: relative;
`;
export const contentContainer = styled.div`
  padding-left: 2.2rem;
  // display: flex;
  margin-top: 0.5rem;
  color: #777777;
  ${textSizes.BaseW1};
`;

export const MoreModalWrapper = styled.span`
  position: relative;
`;

export const MoreButtonWrapper = styled.span`
  ${textSizes.SmallW2};
  color: #2274e0;
  cursor: pointer;
`;

export const BenefitsItemContainer = styled.div``;

export const GTSSStarGradient = styled.div`
  background: linear-gradient(315deg, #f8cd46 0%, #f4a900 100%);
  width: 7px;
  height: 7px;
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  transform: rotate(45deg);
  position: static;
  left: 0;
  top: 8px;
  margin-right: 5px;

  &.star {
    background: linear-gradient(315deg, #ff6d38 0%, #ff3a5c 100%);
  }
`;
export const goTribeIcon = styled.img`
  width: 93px;
`;
export const starIcon = styled.div`
  display: flex;
  align-items: center;
`;
export const Item = styled.p`
  width: auto;
`;

export const starIconImage = styled.img`
  min-width: 10px;
`;

export const GoTribeTagDropDownOuter = styled.div(
  props => `
    position:absolute;
    z-index:6;
    bottom: ${props.positionTop && '100%'};
    top: ${!props.positionTop && '100%'};
    padding-bottom: ${props.positionTop && '1rem'};
    padding-top: ${!props.positionTop && '1rem'};
    left: ${props.forDetailsPage ? '5%' : '0%'};
    margin-left: 100px;
  `,
);

export const GoTribeDropDownHover = styled.div(
  props => `
    width:22rem;
    border-radius: ${props.theme.misc.borderRadius.xlarge};
    padding:11px 16px 16px;
    // background: ${props.backgroundColor || props.theme.colors.goGreen.light};
    // background: linear-gradient(110.28deg, #FFEDE8 0.67%, #FFFFFF 192.42%);
    background: ${
      props.forDetailsPage
        ? 'linear-gradient(101.67deg, #FFEDE8 0.43%, #FFFFFF 160.08%)'
        : 'linear-gradient(97.67deg, #FFFFFF -48.52%, #FFEDE8 83.5%)'
    };
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.15);
    .close {
      top: 20px;
      right: 8px;
      padding: 6px;
      display: block;
      position: absolute;
      width: 25px;
      height: 25px;
      cursor: pointer;
    }
    .close:after,
    .close::before {
      position: absolute;
      left: 11.5px;
      top: 7px;
      content: " ";
      height: 14px;
      width: 1px;
      opacity: 0.5;
      background-color: #46484D;
    }
    .close:before {
      transform: rotate(45deg);
    }
    .close:after {
      transform: rotate(-45deg);
    }
  `,
);

export const header = styled.h3`
  margin-bottom: 0.5rem;
`;

export const ContentWrapper = styled.div`
  padding-top: 1.2rem
  overflow: scroll;
  max-height: 80vh;
  z-index: 100;

  -ms-overflow-style: none; /* Internet Explorer 10+ */
  scrollbar-width: none; /* Firefox */

  ::-webkit-scrollbar {
    display: none; /* Safari and Chrome */
  }
`;
export const FeatureList = styled.ul`
  list-style: none;
`;

export const FeatureListItem = styled.li(
  props => `
display: flex;
align-items: center;
gap: 1rem;
${textSizes.MediumW1};
margin-bottom: ${props.paddingBottom || '0.8rem'};
`,
);

export const IconImg = styled.img`
  min-width: 1.5rem;
  height: 1.5rem;
`;

export const FeaturesListText = styled.p`
  ${textSizes.SmallW1}
`;

export const ContentDescription = styled.span`
  ${textSizes.SmallW1};
`;

export const PackageTag = styled.div`
  height: 20px;
  width: fit-content;
  margin-bottom: 1rem;
  img {
    height: 100%;
  }
`;

export const CheckAvailabilityBtnUIWrapper = styled.div`
  margin-bottom: 10px;
`;
